document.addEventListener('DOMContentLoaded', () => {
	const hero = document.querySelector('.hero');
	if (!hero) return;

	// Entrance animation — додаємо клас після рендеру
	requestAnimationFrame(() => {
		hero.classList.add('hero--visible');
	});
});
